// extracted by mini-css-extract-plugin
module.exports = {"carousel":"product-carousel_carousel__h7Qwg","carousel__card":"product-carousel_carousel__card__N1H1c"};